import { __decorate } from "tslib";
import { Component } from "@angular/core";
var AppRootComponent = /** @class */ (function () {
    function AppRootComponent() {
    }
    AppRootComponent = __decorate([
        Component({
            selector: 'app-root',
            templateUrl: 'app/app-root.html'
        })
    ], AppRootComponent);
    return AppRootComponent;
}());
export { AppRootComponent };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXBwLXJvb3QuY29tcG9uZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vd29ya3BsYWNlTGl2aW5nU2VydmljZXMvc3JjL2FwcC9hcHAtcm9vdC5jb21wb25lbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sRUFBQyxTQUFTLEVBQUMsTUFBTSxlQUFlLENBQUM7QUFNeEM7SUFBQTtJQUVBLENBQUM7SUFGWSxnQkFBZ0I7UUFKNUIsU0FBUyxDQUFDO1lBQ1QsUUFBUSxFQUFFLFVBQVU7WUFDcEIsV0FBVyxFQUFFLG1CQUFtQjtTQUNqQyxDQUFDO09BQ1csZ0JBQWdCLENBRTVCO0lBQUQsdUJBQUM7Q0FBQSxBQUZELElBRUM7U0FGWSxnQkFBZ0IifQ==